import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-regular-svg-icons';
import ConfirmActionButton from '../general/confirmation/ConfirmActionButton';
import FormInput from '../general-components/FormInput';
import { ButtonType } from '../general-components/Button';
import { reportMissingImplant } from '../../services/apiService';

interface ReportMissingImplantButtonProps {
    currentTerm: string;
    onSuccess?: () => void;
}

const ReportMissingImplantButton: React.FC<ReportMissingImplantButtonProps> = ({
    currentTerm,
    onSuccess,
}) => {
    const { t } = useTranslation();

    const [missingImplantData, setMissingImplantData] = useState({
        name: '',
        type: '',
        info: '',
    });

    const handleReportMissingImplant = async () => {
        try {
            await reportMissingImplant({
                searchTerm: currentTerm,
                name: missingImplantData.name,
                type: missingImplantData.type,
                info: missingImplantData.info,
            });
            // Reset form data after successful submission
            setMissingImplantData({
                name: '',
                type: '',
                info: '',
            });
            onSuccess?.();
        } catch (error) {
            console.error('Error reporting missing implant:', error);
        }
    };

    return (
        <ConfirmActionButton
            buttonText={
                <span className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faFlag} />
                    <span className="hidden sm:inline">
                        {t('search.resultsComponent.buttons.reportMissing')}
                    </span>
                </span>
            }
            buttonType={ButtonType.primary}
            modalInfo={{
                title: t('search.resultsComponent.reportMissing.title'),
                message: t('search.resultsComponent.reportMissing.message'),
                submitButtonText: t(
                    'search.resultsComponent.reportMissing.submit'
                ),
                isSubmitted: false,
            }}
            onConfirm={handleReportMissingImplant}
        >
            <div className="space-y-4">
                <FormInput
                    label={t(
                        'search.resultsComponent.reportMissing.searchTerm'
                    )}
                    type="text"
                    defaultValue={currentTerm}
                    disabled={true}
                    onChange={() => {}}
                />
                <FormInput
                    label={t('search.resultsComponent.reportMissing.name')}
                    type="text"
                    defaultValue={missingImplantData.name}
                    onChange={(e) =>
                        setMissingImplantData({
                            ...missingImplantData,
                            name: e.target.value,
                        })
                    }
                    placeholder={t(
                        'search.resultsComponent.reportMissing.namePlaceholder'
                    )}
                />
                <FormInput
                    label={t('search.resultsComponent.reportMissing.type')}
                    type="text"
                    defaultValue={missingImplantData.type}
                    onChange={(e) =>
                        setMissingImplantData({
                            ...missingImplantData,
                            type: e.target.value,
                        })
                    }
                    placeholder={t(
                        'search.resultsComponent.reportMissing.typePlaceholder'
                    )}
                />
                <FormInput
                    label={t('search.resultsComponent.reportMissing.info')}
                    tag="textArea"
                    defaultValue={missingImplantData.info}
                    onChange={(e) =>
                        setMissingImplantData({
                            ...missingImplantData,
                            info: e.target.value,
                        })
                    }
                    placeholder={t(
                        'search.resultsComponent.reportMissing.infoPlaceholder'
                    )}
                />
            </div>
        </ConfirmActionButton>
    );
};

export default ReportMissingImplantButton;
